import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { UmsService } from '../ums.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ModalpopService } from '../modalpop.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageBoxComponent } from '../message-box/message-box.component';
import { Location } from '@angular/common';
@Component({
  selector: 'app-report-exam',
  templateUrl: './report-exam.component.html',
  styleUrls: ['./report-exam.component.scss']
})
export class ReportExamComponent implements OnInit {

  ExamRep: FormGroup;
  dialogRef: MatDialogRef<any>;
  resultyp = false;
  Exam = true;
  Branch = false;
  FrLedger = false;
  CenterCollege = false;
  Clg = false;
  ZnTwn = false;
  RollNo = false;
  Centre = false;
  Dist = false;
  Paper = false;
  Sheet = false;
  UniClg = false;
  Flag = false;
  SoftCp = false;
  Remark = false;
  File = false;
  Subs = false;
  BR2 = false;
  BR1 = false;
  DS1 = false;
  DS2 = false;
  APIService: any;
  filteredDataList: any;
  DataList: any;
  RGInCode = 0;
  G_Regn_Roll = '';
  FlagLabel = '';
  UniColg = 'U';
  StrVldUC = 'UC';
  TitleOne = 'titleOne';
  RollRegn = '';
  TnDist = '';
  ZoneTown = '';
  CourseList: any;
  filteredListCourse: any;
  BranchList: any;
  filteredListBranch: any;
  code: any;
  Arr: any;
  data: any;
  status: any;
  ExamList: any;
  filteredListExam: any;
  DistList: any;
  filteredListDist: any;
  StrFlagVld: string;
  StrFlgDef: string;
  PaperList: any;
  filteredListPaper: any;
  strProc: string;
  BrList: any;
  filteredListBr: any;
  RptTime: any;
  DistrictList: any;
  filteredListDistrict: any;
  submitpayload: any;
  RptName: string;
  spName: any;
  filteredListCollege: any;
  collegeList: any;
  rptCode: any;
  SessionNo: any;
  SessionNo1: any;
  RollNoPay: number;
  RgNoPay: any;
  constructor(public umsService: UmsService, private spinner: NgxSpinnerService,
    private location: Location,
    private modalPopupService: ModalpopService, public router: Router, private httpClient: HttpClient,
    private route: ActivatedRoute, private dialog: MatDialog,
    public fb: FormBuilder) { this.APIService = environment.serviceUrl; }

  ngOnInit(): void {
    if (JSON.parse(sessionStorage.getItem("session")) == null) {
      // this.fetchSecretData();
      this.umsService.getSecretData().subscribe((res) => {
        this.SessionNo = res.projectPharam['SnNo'];
        this.route.queryParams.subscribe((params) => {
          this.RGInCode = params['MenuCode'];
          this.resetValues();
          // this.loadpage(this.RGInCode);
          this.Exam = true;
          this.Branch = false;
          this.FrLedger = false;
          this.CenterCollege = false;
          this.Clg = false;
          this.ZnTwn = false;
          this.RollNo = false;
          this.Centre = false;
          this.Dist = false;
          this.Paper = false;
          this.Sheet = false;
          this.UniClg = false;
          this.Flag = false;
          this.SoftCp = false;
          this.Remark = false;
          this.File = false;
          this.Subs = false;
          this.BR2 = false;
          this.BR1 = true;
          this.DS1 = false;
          this.DS2 = true;
          this.ExamRep = this.fb.group({
            Exam: new FormControl('', Validators.required),
            Branch: new FormControl(''),
            Ledger: new FormControl('S'),
            College: new FormControl(''),
            RollNo: new FormControl(''),
            Centre: new FormControl(''),
            District: new FormControl(''),
            Paper: new FormControl(''),
            SheetNo: new FormControl(''),
            UniClg: new FormControl(''),
            Flag: new FormControl(''),
            SoftCp: new FormControl(''),
            Remark: new FormControl(''),
            CsvFile: new FormControl(''),
            Subject: new FormControl(''),
            ZnTn: new FormControl(''),
            ResultType: new FormControl(''),
            CenterCollege: new FormControl(''),
          });
          this.repDetails(this.RGInCode, this.SessionNo);
          this.fetchCourse();
          // this.getCollegeData();
        });
      }
      );

    }
    else if (JSON.parse(sessionStorage.getItem("session")) != null) {
      let sessionData = JSON.parse(sessionStorage.getItem("session"));
      this.SessionNo = sessionData.SnNo
      this.route.queryParams.subscribe((params) => {
        this.RGInCode = params['MenuCode'];
        this.resetValues();
        // this.loadpage(this.RGInCode);
        this.Exam = true;
        this.Branch = false;
        this.FrLedger = false;
        this.CenterCollege = false;
        this.Clg = false;
        this.ZnTwn = false;
        this.RollNo = false;
        this.Centre = false;
        this.Dist = false;
        this.Paper = false;
        this.Sheet = false;
        this.UniClg = false;
        this.Flag = false;
        this.SoftCp = false;
        this.Remark = false;
        this.File = false;
        this.Subs = false;
        this.BR2 = false;
        this.BR1 = true;
        this.DS1 = false;
        this.DS2 = true;
        this.ExamRep = this.fb.group({
          Exam: new FormControl('', Validators.required),
          Branch: new FormControl(''),
          Ledger: new FormControl('S'),
          College: new FormControl(''),
          RollNo: new FormControl(''),
          Centre: new FormControl(''),
          District: new FormControl(''),
          Paper: new FormControl(''),
          SheetNo: new FormControl(''),
          UniClg: new FormControl(''),
          Flag: new FormControl(''),
          SoftCp: new FormControl(''),
          Remark: new FormControl(''),
          CsvFile: new FormControl(''),
          Subject: new FormControl(''),
          ZnTn: new FormControl(''),
          ResultType: new FormControl(''),
          CenterCollege: new FormControl(''),
        });
        this.repDetails(this.RGInCode, this.SessionNo);
        this.fetchCourse();
        // this.getCollegeData();
      });
    }
  }

  // fetchSecretData() {
  //   this.umsService.getSecretData().subscribe((res) => {
  //     this.SessionNo = res.projectPharam['SnNo']
  //     }
  //   );

  // }

  resetValues() {

  }

  fetchCourse() {
    const payload = {};

    payload['LoginId'] = 0;
    this.umsService.getCourse(payload).subscribe(res => {
      if (res.status) {
        this.CourseList = res.data;
        this.filteredListCourse = this.CourseList.slice();
      }
    });
  }



  repDetails(id, SessionNo) {
    const payload = {};
    payload['RptTime'] = '';
    payload['RptCode'] = id;
    this.umsService.reportDetails(payload).subscribe(res => {
      if (res.status) {
        this.data = res.data[0];
        this.TitleOne = this.data['RptName']
        this.RptTime = this.data['RptTime']
        this.rptCode = this.data['RptCode']
        this.spName = this.data['RptProc']
        if (this.data['RptTime'] == 'O') {
          this.status = 'OARU'
        }
        else if (this.data['RptTime'] == 'A') {
          this.status = 'ARU'
        }
        else if (this.data['RptTime'] == 'R') {
          this.status = 'RU'
        }
        else {
          this.status = '';
        }

        this.fetchExam(this.status, SessionNo)
        this.loadpage(this.data['RptCode'], this.data['RptParam'])
      }
    });
  }

  loadpage(rptCode, rptParam) {
    // rptCode == 20 ||  no need UMS as per EDPS
    if (rptCode == 18) {
      this.resultyp = true
    }
    else {
      this.resultyp = false
    }
    this.ExamRep.controls['Centre'].setValue(1);
    let params = []
    params = rptParam.split(',')
    params.forEach(element => {
      switch (element) {
        case "CgCode":
          this.Clg = true;
          break;
        case "RollNo":
          this.RollNo = true;
          if (this.umsService.secretdata['RegnRoll'] == 'R') {
            this.RollRegn = 'Roll No'
          }
          else {
            this.RollRegn = 'Regn No'
          }
          break;
        case "Subs":
          this.Subs = true;
          break;
        case "Cent":
          this.Centre = true;
          break;
        case "HOM":
          this.Paper = true;
          break;
        case "CsNo":
          this.Sheet = true;
          break;
        case "UC":
          this.UniClg = true;
          break;
        case "BR":
          this.Branch = true;
          break;
        case "File":
          this.File = false;  //as it is not needed now told by shailesh sir 
          break;
        case "Ds":
          this.Dist = true;
          this.TnDist = 'District'
          break;
        case "Zone":
          this.ZnTwn = true;
          this.ZoneTown = 'Zone'
          break;
        case "TnCode":
          this.ZnTwn = true;
          this.ZoneTown = 'Town'
          break;

      }

      let code = 0;
      code = rptCode;
      if (code == 17 || code == 31) {
        this.FrLedger = true;
        this.CenterCollege = true;
        if (this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['ClubPartTrans'] == 13 || this.umsService.secretdata['ClubPartTrans'] == 13 ||
          this.umsService.secretdata['CBCS'] != '') {
          this.FrLedger = false;
          this.ExamRep.controls['Ledger'].setValue('1');
        }
      }
      if ((code == 18 || code == 5) && (this.umsService.secretdata['ClubPartTrans'] == 11)) {
        this.Remark = true;
      }
      switch (code) {
        case 4:
          this.Flag = true;
          this.FlagLabel = 'S-With Subjects';
          this.StrFlagVld = "S";
          this.StrFlgDef = "";
          break;
        case 8:
          this.Flag = true;
          this.FlagLabel = 'S-With Subjects';
          this.StrFlagVld = "S";
          this.StrFlgDef = "";
          break;
        case 6:
          this.Flag = true;
          this.FlagLabel = 'E-Exam C-Course';
          this.StrFlagVld = "EC";
          this.StrFlgDef = "E";
          break;
        case 16:
          this.Flag = true;
          this.FlagLabel = 'E-Exam C-Course';
          this.StrFlagVld = "EC";
          this.StrFlgDef = "E";
          break;
        case 17:
          if (element == 'Flag') {
            this.Flag = true;
            if (this.umsService.secretdata['ClubPartTrans'] == 12) {
              this.FlagLabel = 'E-Edit List';
              this.StrFlagVld = "E";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 6) {
              this.FlagLabel = 'N-NRI Ledger';
              this.StrFlagVld = "N";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 13) {
              this.FlagLabel = 'R-Reval, C-Changes E-Excp';
              this.StrFlagVld = "RCE";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 14 || this.umsService.secretdata['ClubPartTrans'] == 19) {
              this.FlagLabel = 'I-INC';
              this.StrFlagVld = "I";
              this.StrFlgDef = "";
            }
            else {
              this.FlagLabel = 'R-Reval, C-Changes';
              this.StrFlagVld = "RC";
              this.StrFlgDef = "";
            }
          }
          this.ExamRep.controls['Centre'].setValue(2);
          break;
        case 31:
          if (element == 'Flag') {
            this.Flag = true;
            if (this.umsService.secretdata['ClubPartTrans'] == 12) {
              this.FlagLabel = 'E-Edit List';
              this.StrFlagVld = "E";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 6) {
              this.FlagLabel = 'N-NRI Ledger';
              this.StrFlagVld = "N";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 13) {
              this.FlagLabel = 'R-Reval, C-Changes E-Excp';
              this.StrFlagVld = "RCE";
              this.StrFlgDef = "";
            }
            else if (this.umsService.secretdata['ClubPartTrans'] == 14 || this.umsService.secretdata['ClubPartTrans'] == 19) {
              this.FlagLabel = 'I-INC';
              this.StrFlagVld = "I";
              this.StrFlgDef = "";
            }
            else {
              this.FlagLabel = 'R-Reval, C-Changes';
              this.StrFlagVld = "RC";
              this.StrFlgDef = "";
            }
          }
          break;
        case 18:
          this.Flag = false;
          break;
        case 28:
          if (this.umsService.secretdata['ClubPartTrans'] == 12) {
            this.Flag = true;
            this.FlagLabel = 'P-Pass Cert, R-Rank Cert, M-MCI Cert, A-Attemp Cert, C-Conv Cert';
            this.StrFlagVld = "PRMAC";
            this.StrFlgDef = "P";
          }
          break;
        case 37:
          if (this.umsService.secretdata['ClubPartTrans'] == 13) {
            this.Flag = true;
            this.FlagLabel = 'Code/Name?';
            this.StrFlagVld = "Y";
            this.StrFlgDef = "";
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 14 ||
            this.umsService.secretdata['ClubPartTrans'] == 19) {
            this.Flag = true;
            this.FlagLabel = 'Int/Code/Roll?';
            this.StrFlagVld = "ICR";
            this.StrFlgDef = "I";
          }

          if (this.umsService.secretdata['ClubPartTrans'] == 9) {
            this.StrVldUC = 'TPI';
            this.UniColg = 'T/P/I';
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UCP';
            this.UniColg = 'U/C/P';
            this.SoftCp = true;
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 17) {
            this.StrVldUC = 'UCP';
            this.UniColg = 'U/C/P';
          }
          else if (this.umsService.secretdata['ClubPartTrans'] == 14 ||
            this.umsService.secretdata['ClubPartTrans'] == 19 || this.umsService.secretdata['ClubPartTrans'] == 6) {
            this.ExamRep.controls['UniClg'].setValue('C');
          }
          break;
        case 54:
          if (this.umsService.secretdata['ClubPartTrans'] == 15) {
            this.Flag = true;
            this.FlagLabel = 'Zero/All';
            this.StrFlagVld = "Z/A";
            this.StrFlgDef = "A";
          }
          break;
        case 61:
          if (this.umsService.secretdata['ClubPartTrans'] == 17) {
            this.Flag = true;
            this.FlagLabel = 'After Gracing Y/N';
            this.StrFlagVld = "N/Y";
            this.StrFlgDef = "N";
          }
          break;
        case 63:
          if (this.umsService.secretdata['ClubPartTrans'] == 17) {
            this.Flag = true;
            this.FlagLabel = 'L-List';
            this.StrFlagVld = "L/ ";
            this.StrFlgDef = "";
          }
          break;
        case 9:
          if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UP';
            this.UniColg = 'U/P';
          }
          break;
        case 22:
          if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UP';
            this.UniColg = 'U/P';
          }
          break;
        case 23:
          if (this.umsService.secretdata['ClubPartTrans'] == 11) {
            this.StrVldUC = 'UP';
            this.UniColg = 'U/P';
          }
          break;

      }
      this.ExamRep.controls['UniClg'].setValue(this.StrVldUC[0]);

    });
  }

  fetchExam(StrStat, SessionNo) {
    let payload = {};
    payload['LoginId'] = sessionStorage.getItem('userId');
    payload['ShSnNo'] = SessionNo;
    payload['ShStatus'] = StrStat;
    this.umsService.ReportExm(payload).subscribe(res => {
      if (res.status) {
        this.ExamList = res.data;
        this.filteredListExam = this.ExamList.slice();
      }
    });
  }

  getExmData(exm) {
    this.BR2 = false;
    this.BR1 = true;
    this.DS1 = false;
    this.DS2 = true;
    let UC = this.ExamRep.controls['UniClg'].value;
    this.fetchPaper(exm.ShId, UC)
    if (this.status[0] == 'R' && exm.SsShId != 0 && this.umsService.secretdata['ResParam'] == 'D') {
      const payload = {};
      payload['ShId'] = exm.ShId;
      payload['SsProc'] = 'R';
      this.umsService.SearchSTR(payload).subscribe(res => {
        this.BR1 = true;
        this.BR2 = false;
        this.BranchList = res.data;
        this.filteredListBranch = this.BranchList.slice();
        if (exm.ShStatus == 'A') {
          this.strProc = 'B'
        }
        else {
          this.BranchList = [];
        }
      });
    }
    else {
      const payload = {};
      payload['CoCode'] = '';
      payload['EmId'] = exm.ShEmId;
      this.umsService.getExamStream(payload).subscribe(res => {
        if (res.status) {
          this.BR1 = false;
          this.BR2 = true;
          this.BrList = res.data;
          this.filteredListBr = this.BrList.slice();
        }
        else {
          this.BrList = [];
        }
      });
    }

    if (this.RptTime == 'R' && exm.SsShId != 0 && this.umsService.secretdata['ResParam'] == 'D') {
      const payload = {};
      payload['ShId'] = exm.ShId;
      payload['SsProc'] = 'R';
      this.umsService.SearchSTR(payload).subscribe(res => {
        this.DS1 = true;
        this.DS2 = false;
        this.DistrictList = res.data;
        this.filteredListDistrict = this.DistrictList.slice();
        if (exm.ShStatus == 'A') {
          this.strProc = 'D'
        }
        else {
          this.DistrictList = [];
        }
      });
    }
    else {
      const payload = {};
      this.umsService.getDistrict(payload).subscribe(res => {
        if (res.status) {
          this.DS1 = false;
          this.DS2 = true;
          this.DistList = res.data;
          this.filteredListDist = this.DistList.slice();
        }
      });
    }

  }

  fetchPaper(ShId, ColUni) {
    this.spinner.show();
    const payload = {};
    payload['ShId'] = ShId;
    payload['EmId'] = 0;
    payload['EsCollUni'] = ColUni;
    this.umsService.fetchHOM(payload).subscribe(res => {
      if (res.status) {
        this.spinner.hide();
        this.PaperList = res.data;
        this.filteredListPaper = this.PaperList.slice();

      }
      else {
        this.spinner.hide();
      }
    });
  }

  getCollegeData(item) {
    this.spinner.show();
    const payload = {};
    // this.umsService.getCollege(payload).subscribe((res) => {
    //   this.spinner.hide();
    //   this.collegeList = res.data;
    //   this.filteredListCollege = this.collegeList.slice();
    // })
    payload['EmId'] = item.ShEmId;
    this.umsService.getExamCollegeForReport(payload).subscribe((res) => {
      this.spinner.hide();
      this.collegeList = res.data;
      this.filteredListCollege = this.collegeList.slice();
    })

  }


  Print() {
    if (this.ExamRep.invalid) {
      this.ExamRep.get('Exam').markAsTouched();
    }
    else {
      this.submitpayload = this.ExamRep.value;
      var filter: any;
      let payload1 = {}
      payload1['ResultType'] = this.ExamRep.value.ResultType;
      payload1['CenterCollege'] = this.ExamRep.value.CenterCollege;
      let jsonString = JSON.stringify(payload1);
      if (this.RollRegn == 'Roll No') {
        this.RollNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
        this.RgNoPay = '';
      }
      else if (this.RollRegn == 'Regn No') {
        this.RollNoPay = 0;
        this.RgNoPay = this.submitpayload['RollNo'] ? this.submitpayload['RollNo'] : 0;
      }

      if (this.rptCode == 5) {
        filter = {
          "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
          "RptCode": this.rptCode,
          "InstName": '',
          "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
          "ShId": this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '',
          "CgCode": this.submitpayload['College'] ? this.submitpayload['College'] : '',
          "RollNo": this.RollNoPay,
          "Cent": this.submitpayload['Centre'] ? this.submitpayload['Centre'] : 0,
          "TnCode": this.submitpayload['ZnTn'] ? this.submitpayload['ZnTn'] : 0,
          "EsId": this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0,
          "CsNo": '',
          "PgBreak": '',
          "StrId": this.submitpayload['Branch'] ? this.submitpayload['Branch'] : 0,
          "StrCode": '',
          "RgNo": this.RgNoPay,
          "UC": this.submitpayload['UniClg'] ? this.submitpayload['UniClg'] : 0,
          "Ledger": this.submitpayload['Ledger'] ? this.submitpayload['Ledger'] : 'S',
          "RegnRoll": this.umsService.secretdata['RegnRoll'] ? this.umsService.secretdata['RegnRoll'] : '',
          "DsCode": this.submitpayload['District'] ? this.submitpayload['District'] : '',
          "CoCode": '',
          "SnNo": this.SessionNo,
          "Extra1": jsonString,
          "InstCode": 'SSHU',
        }

      }
      else {
        filter = {
          "LoginId": parseInt(sessionStorage.getItem('userId')) ? parseInt(sessionStorage.getItem('userId')) : 0,
          "RptCode": this.rptCode,
          "InstName": '',
          "InstNo": this.umsService.secretdata['ClubPartTrans'] ? this.umsService.secretdata['ClubPartTrans'] : 0,
          "ShId": this.submitpayload['Exam'] ? this.submitpayload['Exam'] : '',
          "CgCode": this.submitpayload['College'] ? this.submitpayload['College'] : '',
          "RollNo": this.RollNoPay,
          "Cent": this.submitpayload['Centre'] ? this.submitpayload['Centre'] : 0,
          "TnCode": this.submitpayload['ZnTn'] ? this.submitpayload['ZnTn'] : 0,
          "EsId": this.submitpayload['Paper'] ? this.submitpayload['Paper'] : 0,
          "CsNo": '',
          "PgBreak": '',
          "StrId": this.submitpayload['Branch'] ? this.submitpayload['Branch'] : 0,
          "StrCode": '',
          "RgNo": this.RgNoPay,
          "UC": this.submitpayload['UniClg'] ? this.submitpayload['UniClg'] : 0,
          "Ledger": this.submitpayload['Ledger'] ? this.submitpayload['Ledger'] : 'S',
          "RegnRoll": this.umsService.secretdata['RegnRoll'] ? this.umsService.secretdata['RegnRoll'] : '',
          "DsCode": this.submitpayload['District'] ? this.submitpayload['District'] : '',
          "CoCode": '',
          "SnNo": this.SessionNo,
          "Extra1": jsonString,

        }
      }



      if (filter.ShId == '' && this.umsService.secretdata['ClubPartTrans'] != 12) {
        let data = {};
        data['message'] = 'Select Exam';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
      if (this.strProc == 'B' && filter.StrId == 0) {
        let data = {};
        data['message'] = 'Select Processed Branch';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }
      else if (this.strProc == 'D' && filter.StrId == 0) {
        let data = {};
        data['message'] = 'Select District';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
          AlertBoxComponent,
          data
        );
      }

      // && (this.umsService.secretdata['ClubPartTrans'] == 3 || this.umsService.secretdata['ClubPartTrans'] == 18)
      if (this.rptCode == 9 && (this.umsService.secretdata['ClubPartTrans'] == 3 || this.umsService.secretdata['ClubPartTrans'] == 18)) {
        let data = {};
        data['message'] = 'Select from dropdown';
        data['title'] = 'Information';
        data['icon'] = 'fas fa-box-open';
        this.dialogRef = this.dialog.open(MessageBoxComponent, {
          disableClose: true,
          data,
        });
      }

      let strLedger = ''
      if (this.rptCode == 17 || this.rptCode == 31) {
        strLedger = filter.CentCg
        if (strLedger == 'S') {
          if (this.BrList.length > 0 && filter.StrId == 0) {
            let data = {};
            data['message'] = 'Select Branch';
            data['title'] = 'Information';
            data['icon'] = 'fas fa-box-open';
            this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(
              AlertBoxComponent,
              data
            );
          }

        }
      }

      if (this.umsService.secretdata['ClubPartTrans'] == 11 && filter.Remark != '') {
        if (this.rptCode == 18) {
          this.resultyp = true;
          const payload = {};
          payload['ShId'] = '';
          payload['RollNo'] = '';
          payload['Remark'] = '';
          payload['Flag'] = '';
          this.umsService.MarkLRem(payload).subscribe(res => {

            if (res.status) {

            }
            else {

            }
          });
        }
        else {
          const payload = {};
          payload['ShId'] = '';
          payload['RollNo'] = '';
          payload['Remark'] = '';
          payload['Flag'] = '';
          this.umsService.AdmitRem(payload).subscribe(res => {

            if (res.status) {

            }
            else {

            }
          });
        }
      }


      var payload: any;
      payload = filter;


      this.umsService.setData(JSON.stringify(payload));
      this.redirect('reports')
    }
  }

  redirect(to): void {
    this.router.navigate([to]);
  }



  Back() {
    this.goBack();
  }
  goBack(): void {
    this.location.back(); // This will navigate back to the previous page
  }
}
